<script>
/* eslint-disable */
</script>
<template>
      <div>
      <div class="form-group">
        <label for="additional-emails">Emails adicionais (separados por vírgula)</label>
        <input
          id="additional-emails"
          v-model="additionalEmails"
          type="text"
          class="form-control"
          placeholder="Digite os emails adicionais"
        />
        <button
          @click="handleEmailsChange"
          class="btn btn-primary mt-2"
          :disabled="isLoading"
        >
          {{ isLoading ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
</template>

<script>
import api from "@/libs/axios";

export default {
  data() {
    return {
      additionalEmails: "",
      id_account_verdesys: "",
      email: "",
      isLoading: false
    };
  },
  created() {
    this.id_account_verdesys = JSON.parse(localStorage.getItem("id_account_verdesys"));
    this.email = JSON.parse(localStorage.getItem("user")).email;
  },
  mounted() {
    this.getIuguAccount();
  },
  methods: {
    async handleEmailsChange() {
      this.isLoading = true;
      try {
        const response = await api.patch("/accounts/iugu-edit/" + this.id_account_verdesys, {
          cc_emails: this.additionalEmails,
          email: this.email
        });
        this.toast({
              title: 'Dados Alterados!',
              text: 'Seus dados na Iugu foram alterados com sucesso.',
              variant: 'success',
            })
      } catch (error) {
        this.toast({
              title: 'Erro ao alterar dados!',
              text: 'Ocorreu um erro ao alterar os dados.',
              variant: 'error',
            })
      } finally {
        this.isLoading = false;
      }
    },
    async getIuguAccount() {
      try {
        const response = await api.get("/accounts/iugu-edit/" + this.email);
        this.additionalEmails = response.data.cc_emails;
      } catch (error) {
        console.error("Erro ao buscar conta Iugu:", error);
      }
    }
  }
};
</script>

<style scoped>
.form-group {
  max-width: 500px;
}
</style>
